import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LoginFooter = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="mt-6 md:mt-8 space-y-4">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 text-sm">
        <button
          onClick={() => navigate('/forgot-password')}
          className="text-muted-foreground hover:text-foreground transition-colors font-medium"
        >
          {t('auth.login.forgotPassword')}
        </button>
      </div>
    </div>
  );
};

export default LoginFooter;
